import user from './user'
import system from './system'
import oceanFreight from './oceanFreight'
import airFreight from './airFreight'
import reconciliationManagement from './reconciliationManagement'
import billManagement from './billManagement'
import coop from './coop'
import marketingBanner from './marketingBanner'
import workbench from './workbench'
import vipPageTemplate from './vipPageTemplate'
export default {
  user,
  system,
  oceanFreight,
  airFreight,
  reconciliationManagement,
  billManagement,
  coop,
  marketingBanner,
  workbench,
  vipPageTemplate
}
